{
  "instances": {
    "logfile": {
      "label": "日誌檔案",
      "download": "下載",
      "wrap_lines": "自動換行",
      "page_up": "向上翻頁",
      "page_down": "向下翻頁",
      "previous_chunk": "上一段",
      "next_chunk": "下一段",
      "resume_follow": "恢復追蹤",
      "stop_follow": "停止追蹤",
      "reconnecting": "正在重新連線...",
      "compressed_reset": "記錄檔已壓縮，正在重設頁面。"
    }
  }
}
